(function() {
    'use strict';

    window.addEventListener('DOMContentLoaded', onReady);

    window.addEventListener('click', (e) => {
        if (matchesSelector(e.target, '.widget--checkout-back')) {
            document.dispatchEvent(new Event('checkoutback'));
        }
    });

    function onReady() {
        const form = document.querySelector(
            '.wc-svea-checkout-page .wc-svea-checkout-form',
        );

        if (form) {
            setTimeout(function() {
                jQuery(form).trigger('sco_save_order_information');
            }, 100);
        }

        if (window.top === window.self) {
            // Not running in iframe. Boooh.
            return;
        }

        communicateWithParent('init', {height: getHeight()});
        pollForHeightAdjustment();
    }

    function pollForHeightAdjustment() {
        communicateWithParent('size', {height: getHeight()});

        setTimeout(function() {
            requestAnimationFrame(pollForHeightAdjustment);
        }, 100);
    }

    function communicateWithParent(action, data = null) {
        if (!data) {
            data = {};
        }

        window.top.postMessage({
            combinr: true,
            action,
            ...data,
        }, '*');
    }

    function getHeight() {
        return document.body.scrollHeight;
    }

    function matchesSelector(target, selector) {
        if (!target) {
            return false;
        }

        if (target.matches(selector)) {
            return true;
        }

        return matchesSelector(target.parentElement, selector);
    }
}());

//# sourceMappingURL=widget.js.map
